import { createStore } from 'vuex'

export default createStore({
    state: {
        basePath: location.protocol + '//' + location.hostname,
        send: false,
        sendSuccess: false
    },
    mutations: {
        changeSuccess (state, payload) {
            state.sendSuccess = payload
        }
    },
    actions: {
        async Send (context, payload) {
            if ((process.env.NODE_ENV === 'development')) {
                console.log(payload)
            } else {
                const fields = {
                    title: payload.setting.title,
                    subject: payload.setting.subject,
                    formDate: payload.setting.formDate,
                    fields: payload.fields
                }

                const formData = new FormData()
                formData.append('fields', JSON.stringify(fields))

                if (payload.files !== '') {
                    for (let i = 0; i < payload.files.length; i++) {
                        let file = payload.files[i]
                        formData.append('files[' + i + ']', file)
                    }
                }

                const response = await fetch(`/api/v1/send_form/`, {
                    method: 'POST',
                    body: formData
                })

                const result = await response.json()
                console.log(result)

                if (result.send) {
                    window.location.href = payload.redirectPage
                }
            }
        }
    },
    modules: {
    },
    getters: {
        isSend: s => s.send,
        sendSuccess: s => s.sendSuccess
    }
})
